import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from '../../../theme';

export const StyledWhenHighlights = styled.div`
  padding-bottom: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${screen('md')}) {
    border-bottom: 1px solid ${color('midnight_200')};
    border-top: 1px solid ${color('midnight_200')};
  }
`;

export const StyledWhenHighlightsIntro = styled.div`
  font-size: ${fontSize('sm')};
  text-align: center;
  max-width: ${container('sm')};
  margin: ${spacing('xs')} auto ${spacing('sm')};
  
`;

export const StyledWhenHighlightsList = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl3')};
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${screen('md')}) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: ${spacing('xl')} ${spacing('xl3')};
    margin-top: ${spacing('md')};
  }
`;
